// extracted by mini-css-extract-plugin
module.exports = {"statistic":"Statistic_statistic__Vm0-P","figure":"Statistic_figure__1veBA","label":"Statistic_label__1jEHL"};